import { useSearchParams } from 'react-router-dom';
import { LawsuitsTab } from '../LawsuitsTab';
import { ClaimsTab } from './ClaimsTab';
import { TopTab, TopTabs } from './styles';
import type { TabKey } from './types';

export function Claims() {
  // URL-state для активной вкладки: `?tab=lawsuits` — иначе всегда «Претензии».
  // Это даёт shareable links и сохранение вкладки при refresh.
  const [searchParams, setSearchParams] = useSearchParams();
  const tab: TabKey = searchParams.get('tab') === 'lawsuits' ? 'lawsuits' : 'claims';

  function switchTab(next: TabKey) {
    const params = new URLSearchParams(searchParams);
    if (next === 'lawsuits') params.set('tab', 'lawsuits');
    else params.delete('tab');
    setSearchParams(params, { replace: true });
  }

  return (
    <>
      <TopTabs role="tablist" aria-label="Реестры юридических документов">
        <TopTab
          type="button"
          role="tab"
          aria-selected={tab === 'claims'}
          $active={tab === 'claims'}
          onClick={() => switchTab('claims')}
        >
          Претензии
        </TopTab>
        <TopTab
          type="button"
          role="tab"
          aria-selected={tab === 'lawsuits'}
          $active={tab === 'lawsuits'}
          onClick={() => switchTab('lawsuits')}
        >
          Иски
        </TopTab>
      </TopTabs>

      {tab === 'claims' ? <ClaimsTab /> : <LawsuitsTab />}
    </>
  );
}
